module.exports = __webpack_public_path__ + "img/ERNIE-SLIDER-01.8d97dfd0.jpg";